export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_Contactus-1d1cd8f1ac44092f110ecd3d4b891d76.jpg";